module.exports = __webpack_public_path__ + "static/media/s60.f602756a.jpg";